import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useColors } from "@rmp/core/composables/useColors";

interface Props {
	title: String;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSignInFormBase',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
	title: String;
};

const { colors } = useColors();



const portalUrl = process.env.VUE_APP_PORTAL_BASE_URL;

return { __sfc: true,colors, props, portalUrl, RmpText, RmpIcon }
}

})